module.exports = __webpack_public_path__ + "img/4.8bc4bf1b.gif";